module.exports = __webpack_public_path__ + "img/10551378_L.82c3b7bb.png";